import React, {useEffect, useState} from 'react'
import { observer } from 'mobx-react-lite'
import {formatPrice} from "../../utils/format-price";
import Translator from "../translator";
import clx from "classnames";
import { ValidateAddParticipantController } from '../../datastores/validateAddParticipantController'
import {Participant} from "../../datastores/participant";
import {reaction} from "mobx";
import { RootStore } from '../../datastores/rootStore'
import GA4Tracking from '../../utils/ga4-tracking'

const Addon = observer(function Addon({eventGroup, addon}) {

  const [loading, setLoading] = useState(false);
  const [validateAddParticipantController] = useState(() => new ValidateAddParticipantController())

  const toggleAddon = async () => {
    let participantsCount = Object.keys(eventGroup.participants).length

    if(eventGroup.hasAddon(addon)) {
      eventGroup.removeAddon(addon)
      GA4Tracking.handleUpdateOfAddonsInCart(addon, participantsCount, 'remove_from_cart')
      return
    }

    setLoading(true)

    eventGroup.addAddon(addon);

    await eventGroup.updateAddonParticipants(addon, RootStore.getInstance().cart.customer, RootStore.getInstance().cart.coupon)
    await RootStore.getInstance().cart.validateContent()

    GA4Tracking.handleUpdateOfAddonsInCart(addon, participantsCount, 'add_to_cart')

    setLoading(false);
  }

  useEffect(() => {
    reaction(
      () => eventGroup.participants.map(p=>p.email),
      async (participants) => {
        setLoading(true);
        await eventGroup.updateAddonParticipants(addon, RootStore.getInstance().cart.customer, RootStore.getInstance().cart.coupon)
        await RootStore.getInstance().cart.validateContent()
        setLoading(false);
      }
    )
  }, [])

  return (
    <div className="mtt-cart-addon-product" key={addon.id}>
      <div className={"mtt-cart-addon-product__content"}>
        <div className={clx("input checkbox-wrapper blue small", { loading: loading})}>
          <input
            id={"addon_" + eventGroup.id + '_' + addon.id}
            type="checkbox"
            name={"addon_" + eventGroup.id + '_' + addon.id}
            hidden="hidden"
            checked={eventGroup.hasAddon(addon)}
            disabled={loading}
            onChange={async () => {
              toggleAddon()
            }}
          />
          <label htmlFor={"addon_" + eventGroup.id + '_' + addon.id}>
            <div className="mtt-cart-addon-product__title">{addon.title}</div>
            <div className="mtt-cart-addon-product__subtitle">
              {addon.subtitle}
            </div>
          </label>
        </div>
        <div>
          <div className="mtt-cart-addon-product__price">{formatPrice(addon.price ?? 0)}</div>
          <div className="mtt-cart-addon-product__subtitle">{Translator.translate('Per person ekskl. moms', 'participant')}</div>
        </div>
      </div>
      {validateAddParticipantController.isAllValid ? null : (
        <div className='validation-message'>
          {Object.entries(validateAddParticipantController.validation_data?.[addon.id]?.errors??{}).map(([key, error]) => (
            <div key={key}>{error}</div>
          ))}
        </div>
      )}

    </div>
  )
})
export default Addon
